export default {
  methods: {
    getPackageTile: function (hnlSummary) {
      const el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML =
        `<div class="facade-image">
          <figure class="image">
            <img src="${hnlSummary.imagepath}" alt="">
          </figure>
        </div>`;

      const infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.classList.add('pb-0');
      infoEl.classList.add('pt-2');
      infoEl.innerHTML = `
        <div class="columns is-mobile is-gapless">
          <div class="column design">
            <p class="design">${hnlSummary.designproductname}</p>
            <p class="d">${hnlSummary.buildername}</p>
            <p class="mt-2 pr-1">${hnlSummary.productaddress}</p>
          </div>
          <div class="column is-narrow">
            <div class="amenities">
              <div class="amenity">
                <img src="${require('@/assets/icons/bed.svg')}" alt="">
                  <span>${hnlSummary.noofbedrooms}</span>
              </div>
              <div class="amenity">
                <img src="${require('@/assets/icons/bath.svg')}" alt="">
                  <span>${hnlSummary.noofbathrooms}</span>
              </div>
              <div class="amenity">
                <img src="${require('@/assets/icons/car.svg')}" alt="">
                  <span>${hnlSummary.noofcarparks}</span>
              </div>
            </div>
            <div class="price">
              <p class="p">$${ hnlSummary.planPrice
                < hnlSummary.productprice ? hnlSummary.planPrice
                .toLocaleString() : hnlSummary.productprice.toLocaleString()}</p>
            </div>
          </div>
        </div>
      `
      el.appendChild(infoEl);
      return el;
    },

    getPackageDetailTile: function (hnlSummary) {
      const el = document.createElement('div');
      el.classList.add('home-select-popup', 'card');
      el.innerHTML =
        `<div class="facade-image">
          <figure class="image">
            <img src="${hnlSummary.imagepath}" alt="">
          </figure>
        </div>`;

      const infoEl = document.createElement('div');
      infoEl.classList.add('card-info');
      infoEl.classList.add('pb-0');
      infoEl.classList.add('pt-2');
      infoEl.innerHTML = `
        <div class="columns is-mobile is-gapless">
          <div class="column design">
            <p class="design">${hnlSummary.designproductname}</p>
            <p class="d">${hnlSummary.buildername}</p>
            <p class="mt-2 pr-1">${hnlSummary.productaddress}</p>
          </div>
          <div class="column is-narrow">
            <div class="amenities">
              <div class="amenity">
                <img src="${require('@/assets/icons/bed.svg')}" alt="">
                  <span>${hnlSummary.noofbedrooms}</span>
              </div>
              <div class="amenity">
                <img src="${require('@/assets/icons/bath.svg')}" alt="">
                  <span>${hnlSummary.noofbathrooms}</span>
              </div>
              <div class="amenity">
                <img src="${require('@/assets/icons/car.svg')}" alt="">
                  <span>${hnlSummary.noofcarparks}</span>
              </div>
            </div>
          </div>
        </div>
      `
      el.appendChild(infoEl);
      return el;
    },


    getPackageDimensionTile: function (hnlSummary) {
      return `<div class="columns is-mobile is-gapless">
            <div class="column dimensions">
              <div class="dimension">
                <p class="t">Home Area</p>
                <p class="d">${hnlSummary.homesize}<small> sq ft</small></p>
              </div>

              <div class="dimension">
                <p class="t">Elevation</p>
                <p class="d">${hnlSummary.facadeproductname}</p>
              </div>

              <div class="dimension">
                <p class="t">Frontage</p>
                <p class="d">${hnlSummary.homewidth}'</p>
              </div>

              <div class="dimension">
                <p class="t">Lot Area</p>
                <p class="d">${hnlSummary.lotsize} sq ft</p>
              </div>

              <div class="dimension">
                <p class="t">Stories</p>
                <p class="d">${hnlSummary.noofstoreys}</p>
              </div>

              <div class="dimension">
                <p class="t">Completion</p>
                <p class="d">${hnlSummary.estimatedcompletiondate || 'N/A'}</p>
              </div>
            </div>
          </div>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/map/Popup.js